import { render } from "./Paywall.vue?vue&type=template&id=78e04e0b&scoped=true"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"

import "./Paywall.vue?vue&type=style&index=0&id=78e04e0b&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e04e0b"],['__file',"src/views/paywall/Paywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78e04e0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78e04e0b', __exports__)) {
    console.log('reload')
    api.reload('78e04e0b', __exports__)
  }
  
  module.hot.accept("./Paywall.vue?vue&type=template&id=78e04e0b&scoped=true", () => {
    console.log('re-render')
    api.rerender('78e04e0b', render)
  })

}


export default __exports__